import { DefaultTheme } from 'styled-components';

const DarkTheme: DefaultTheme = {
    palette: {
        text: {
            primary: '#EEEEEE',
            secondary: '#FFD460',
        },
        background: {
            default: '#12151B',
            paper: '#393E46',
            selected: '#911F27',
            background: '#090A0D',
        },
        divider: 'rgba(255, 255, 255, 0.50)',
    },
};

export default DarkTheme;
